import React, { useState } from "react";
import { DropzoneDialog } from "material-ui-dropzone";
import { FormControl } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import Controls from ".";

const useStyles = makeStyles((theme) =>
  createStyles({
    previewChip: {
      minWidth: 160,
      maxWidth: 210,
    },
  })
);

export default function FileDialogIcon(props) {
  const { label, onChange, value, icon, ...rest } = props;
  const [open, setOpen] = useState(false);

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = (files) => {
    onChange(files);
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const classes = useStyles();

  return (
    <FormControl>
      <Controls.IconButton {...rest} onClick={handleOpen}>
        {icon}
      </Controls.IconButton>

      <DropzoneDialog
        open={open}
        filesLimit={1}
        onSave={handleSave}
        acceptedFiles={["application/pdf", "image/jpeg", "image/png"]}
        maxFileSize={1073741824}
        onClose={handleClose}
        showPreviews={true}
        showPreviewsInDropzone={false}
        useChipsForPreview
        previewGridProps={{ container: { spacing: 1, direction: "row" } }}
        previewChipProps={{ classes: { root: classes.previewChip } }}
        previewText="Selected files"
        submitButtonText="Accept"
      />
    </FormControl>
  );
}
